export default __webpack_public_path__ + "static/getStartedImg-36d8d4e513d4e7daed2f0e5be6d5872f.png";